module.exports = __webpack_public_path__ + "static/media/Compass_Rotation_Animation_2.f5dadfff.gif";